// change field name
export const changeFieldName = (list, oldName, newName) => {
    list
        .map(el => {
            el[newName] = el[oldName];
            delete el[oldName];});
    return list;

};

export const randomNum = () => {
    return Math.floor((Math.random() * 100) + 1)
};

export const dataReady = (object) => {
    let contentsReady = false;
    let bodyReady = object.body && object.body[0];
    if (bodyReady) {
        contentsReady = true;
    }
    return contentsReady;
};




// WEBPACK FOOTER //
// src/client/components/site/features/profile/helpers/generalHelpers.js